import { Breadcrumbs, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

function BreadcrumbsWrapper({ breadcrumbs = [] }) {
  return (
    <div>
      {Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && (
        <Breadcrumbs aria-label="breadcrumb">
          {breadcrumbs.map((item, index) => {
            if (breadcrumbs.length - 1 === index) {
              return (
                <Typography key={index} sx={{ color: 'text.primary' }}>
                  {item?.title}
                </Typography>
              );
            }
            return (
              <Link
                underline="hover"
                color="inherit"
                to={item?.path}
                key={index}
              >
                {item?.title}
              </Link>
            );
          })}
        </Breadcrumbs>
      )}
    </div>
  );
}

export default BreadcrumbsWrapper;
